import { HospitalizationsComponent } from './pages/medical-record/hospitalizations/hospitalizations.component';
import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import {
  AppLayoutComponent,
  AuthGuard,
  InboxComponent,
  LoginComponent,
  NotfoundComponent,
  RegisterComponent,
  SettingsComponent,
} from 'shared';

@NgModule({
  imports: [
    RouterModule.forRoot(
      [
        {
          path: '',
          component: AppLayoutComponent,
          children: [
            {
              path: '',
              data: { breadcrumb: 'Προφίλ' },
              loadComponent: () =>
                import('./pages/dashboard/dashboard.component').then(
                  (m) => m.DashboardComponent
                ),
              canActivate: [AuthGuard],
            },
            {
              path: 'calendar',
              data: { breadcrumb: 'Ημερολόγιο​' },
              loadComponent: () =>
                import('./pages/calendar/calendar.component').then(
                  (m) => m.CalendarComponent
                ),
              canActivate: [AuthGuard],
            },
            // {
            //   path: 'compensations',
            //   data: { breadcrumb: '' },
            //   loadComponent: () =>
            //     import('./pages/compensations/compensations.component').then(
            //       (m) => m.CompensationsComponent
            //     ),
            //   canActivate: [AuthGuard],
            // },
            {
              path: 'insurer',
              data: { breadcrumb: 'Ο ασφαλιστής μου' },
              loadComponent: () =>
                import('./pages/insurer/insurer.component').then(
                  (m) => m.InsurerComponent
                ),
              canActivate: [AuthGuard],
            },

            {
              path: 'claims',
              data: { breadcrumb: 'Οι απαιτήσεις​ μου' },
              loadComponent: () =>
                import('./pages/claims/claims.component').then(
                  (m) => m.ClaimsComponent
                ),
              canActivate: [AuthGuard],
            },

            {
              path: 'insurance-contracts',
              data: { breadcrumb: 'Τα συμβόλαιά μου' },
              loadComponent: () =>
                import(
                  './pages/insurance-contracts/insurance-contracts.component'
                ).then((m) => m.InsuranceContractsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'visit-form',
              data: { breadcrumb: 'Ραντεβού με ιατρό' },
              loadComponent: () =>
                import('./pages/visit-form/visit-form.component').then(
                  (m) => m.VisitFormComponent
                ),
              canActivate: [AuthGuard],
            },
            {
              path: 'book-exams',
              data: { breadcrumb: 'Ραντεβού με διαγνωστικό κέντρο' },
              loadComponent: () =>
                import(
                  './pages/book-examinations/book-examinations.component'
                ).then((m) => m.BookExaminationsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'visit-hospital',
              data: { breadcrumb: 'Ραντεβού με νοσοκομείο' },
              loadComponent: () =>
                import(
                  './pages/visit-hospital/visit-hospital.component'
                ).then((m) => m.VisitHospitalComponent),
              canActivate: [AuthGuard],
            },

            {
              path: 'doctor-details/:id',
              data: { breadcrumb: '' },
              loadComponent: () =>
                import(
                  './pages/visit-form/doctor-details/doctor-details.component'
                ).then((m) => m.DoctorDetailsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'insured-assistant',
              data: { breadcrumb: 'Ασφαλιστικός σύμβουλος' },
              loadComponent: () =>
                import('./pages/llm-chat/llm-chat.component').then(
                  (m) => m.LlmChatComponent
                ),
              canActivate: [AuthGuard],
            },
            {
              path: 'diagnostic-center-details/:id',
              data: { breadcrumb: '' },
              loadComponent: () =>
                import(
                  './pages/book-examinations/diagnostic-center-details/diagnostic-center-details.component'
                ).then((m) => m.DiagnosticCentersDetailsComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'hospital-details/:id',
              data: { breadcrumb: '' },
              loadComponent: () =>
                import(
                  './pages/visit-hospital/hospital-details/hospital-details.component'
                ).then((m) => m.HospitalDetailsComponent),
              canActivate: [AuthGuard],
            },
                        {
              path: 'automated-book/:doctorId',
              data: { breadcrumb: '' },
              loadComponent: () =>
                import(
                  './pages/llm-book-appointment/llm-book-appointment.component'
                ).then((m) => m.LlmBookAppointmentComponent),
              canActivate: [AuthGuard],
            },
            {
              path: 'medical_record',
              data: { breadcrumb: 'Φάκελος Υγείας' },
              loadChildren: () =>
                import('./pages/medical-record/medical-record.module').then(
                  (m) => m.MedicalRecordModule
                ),
              canActivate: [AuthGuard],
            },
            {
              path: 'prescriptions-references',
              data: { breadcrumb: 'Συνταγές/Παραπεμπτικά' },
              loadChildren: () =>
                import(
                  './pages/prescriptions-references/prescriptions-references.module'
                ).then((m) => m.PrescriptionsReferencesModule),
              canActivate: [AuthGuard],
            },
            {
              path: 'messages',
              component: InboxComponent,
              canActivate: [AuthGuard],
            },
            {
              path: 'video-room',
              loadChildren: () => import('./pages/video-room/video-room.module').then(m => m.VideoRoomModule),
              canActivate: [AuthGuard],
            },
            {
              path: 'video-room/:roomId',
              loadChildren: () => import('./pages/video-room/video-room.module').then(m => m.VideoRoomModule),
              canActivate: [AuthGuard],
            },
            {
              path: 'settings',
              component: SettingsComponent,
            },
          ],
        },
        { path: 'login', component: LoginComponent },

        { path: 'register', component: RegisterComponent },

        {
          path: 'notfound',
          component: NotfoundComponent,
          canActivate: [AuthGuard],
        },
        { path: '**', redirectTo: '/notfound' },
      ],
      {
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
        onSameUrlNavigation: 'reload',
      }
    ),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
